import { useEffect, useState } from 'react';
import { formatCountdown } from '../utils/formatCountdown';
import { DepartureOrArrival } from '@shared/models/departureOrArrival';
import { DepartureOrArrivalTimeFormat } from '@shared/models/departureOrArrivalTimeFormat';
import { timeToClockFormat } from '@shared/utils/time';
import { getHasChangedTargetClockTime } from '@shared/utils/departureOrArrival';

export function useDepartureDisplayTime(
  departureOrArrival: DepartureOrArrival | undefined,
  format: DepartureOrArrivalTimeFormat,
) {
  const [displayTime, setDisplayTime] = useState<number | string | undefined>();

  useEffect(() => {
    function getDisplayTime(
      departureOrArrival: DepartureOrArrival | undefined,
    ): number | string | undefined {
      if (
        !departureOrArrival ||
        (format === 'time' && !getHasChangedTargetClockTime(departureOrArrival))
      ) {
        return undefined;
      }

      if (departureOrArrival.isCancelled) {
        return 'Inställd';
      }

      if (format === 'time') {
        return timeToClockFormat(departureOrArrival.time);
      }

      return formatCountdown(departureOrArrival.time);
    }

    setDisplayTime(getDisplayTime(departureOrArrival));

    const intervalId = setInterval(() => {
      setDisplayTime(getDisplayTime(departureOrArrival));
    }, 1000);

    return () => {
      clearInterval(intervalId);
    };
  }, [departureOrArrival, format]);

  return displayTime;
}
